export var APP_PATH = '/ezway';
export var loginIntra = 'login_intra';
export var loginInvoice = 'inv-login';
export var announcement = 'announcement';
export var chtNum = 2; // 姓名至少 x 個中文字
export var localUrl = 'http://localhost:8080/';
// export const ApiUrl = "http://172.31.70.72:8227/APECCS/ezway/"
export var HOST = process.env.REACT_APP_SERVER;
export var HOST_DELIVER = process.env.REACT_APP_SERVER_DELIVER;
// export const ApiUrl = 'https://cors-anywhere.herokuapp.com/' + process.env.REACT_APP_SERVER
/** userType: 'TRADEVAN' */
export var TRADEVAN = 'TRADEVAN';
export var CUSTOMER = 'CUSTOMER';
export var EZWAY = 'EZWAY';
